var map = {
	"./cert17semanacientifica.png": "f68e",
	"./certOpas.jpeg": "58c9",
	"./certUFF.jpeg": "2c70",
	"./certrosalda.png": "2475",
	"./corenrj.jfif": "1302",
	"./corenrj.jpg": "fed2",
	"./icons/letra-p.png": "86c9",
	"./icons/lista-de-afazeres.png": "909c",
	"./icons/medalha.png": "b439",
	"./icons/mpox.gif": "fd37",
	"./icons/pilulas.png": "b02c",
	"./icons/ponto-de-interrogacao.png": "0856",
	"./icons/recompensa.png": "dc2f",
	"./icons/saude.png": "f4ad",
	"./icons/sintomas.png": "7791",
	"./icons/sobre-nos.png": "0489",
	"./icons/video.png": "62d9",
	"./icons/violencia.png": "9d89",
	"./imagemHPV.jpg": "41f7",
	"./imagemSifilis.jpg": "c840",
	"./imagemaids.jpg": "ad7f",
	"./listvig.jfif": "cbd0",
	"./lisvig.jpg": "225e",
	"./logo.png": "cf05",
	"./logo.svg": "9b19",
	"./registro.pdf": "b645",
	"./registro.png": "0ebb",
	"./research.png": "2cf3",
	"./virus.png": "1f72"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1771";